{
  "workerPreview": {
    "title": "Trabajadores del sistema externo",
    "intro": "Al confirmar, las seguras se vinculan, los nuevos se crean sin invitación y los de revisión pasan a la bandeja.",
    "tabsLabel": "Clasificación de la vista previa",
    "tabs": {
      "LINK": "Seguras",
      "CREATE": "Nuevos",
      "REVIEW": "Para revisión",
      "ERROR": "Con error",
      "ONLY_IN_FERMIN": "Solo en Fermin"
    },
    "tabCount": "{label} ({count})",
    "caption": "Trabajadores externos: {label}",
    "columns": {
      "externalId": "Id externo",
      "name": "Nombre",
      "document": "Documento",
      "sites": "Sedes externas",
      "candidate": "En Fermin",
      "reason": "Motivo",
      "message": "Detalle",
      "worker": "Trabajador",
      "status": "Estado"
    },
    "primary": "{site} (principal)",
    "noSites": "Sin sedes",
    "noCandidate": "Se creará",
    "empty": {
      "LINK": "Ningún trabajador coincide con uno de Fermin.",
      "CREATE": "No hay trabajadores nuevos.",
      "REVIEW": "No hay casos para revisar.",
      "ERROR": "Ningún registro tiene errores.",
      "ONLY_IN_FERMIN": "Todos los trabajadores de Fermin tienen contraparte."
    },
    "onlyInFerminHint": "Siguen gestionados en Fermin; puedes vincularlos más adelante.",
    "loadFailed": "No pudimos cargar los trabajadores de la vista previa",
    "retry": "Reintentar",
    "loadMore": "Cargar más"
  },
  "table": {
    "title": "Casos para revisar",
    "subtitle": "Fermin no vincula en silencio: decide tú los casos dudosos o con datos faltantes.",
    "caption": "Casos de revisión de la integración",
    "external": "En el sistema externo",
    "reasons": "Motivos",
    "candidates": "Posibles coincidencias",
    "seenAt": "Visto",
    "actions": "Acciones",
    "noCandidates": "Ninguna",
    "entityType": {
      "SITE": "Sede",
      "WORKER": "Trabajador"
    },
    "resolve": "Resolver",
    "resolveLabel": "Resolver el caso de {name}",
    "reopen": "Volver a revisar",
    "reopenLabel": "Volver a revisar el caso de {name}",
    "reopened": "El caso volvió a la bandeja",
    "skippedOn": "Omitido el {date}",
    "emptyTitle": "No hay casos pendientes",
    "emptyDescription": "Cuando una sincronización encuentre algo dudoso, aparecerá aquí.",
    "emptySkippedTitle": "No hay casos omitidos",
    "emptySkippedDescription": "Los casos que omitas se guardan aquí hasta que los vuelvas a revisar.",
    "noResults": "Ningún caso coincide con los filtros.",
    "loadFailed": "No pudimos cargar la bandeja de revisión",
    "retry": "Reintentar",
    "loadMore": "Cargar más",
    "document": "{type} {number}",
    "coordinates": "Sin ubicación"
  },
  "resolve": {
    "title": "Resolver caso",
    "description": "Compara el registro externo con los datos de Fermin y elige qué hacer.",
    "externalTitle": "Sistema externo",
    "ferminTitle": "En Fermin",
    "reasonsTitle": "Por qué está aquí",
    "noCandidate": "Elige un candidato o busca otro para comparar.",
    "candidatesLabel": "Candidatos",
    "searchLabel": "Buscar otro en Fermin",
    "searchPlaceholder": "Elige un registro no vinculado",
    "searchInput": "Escribe para buscar",
    "searchEmpty": "Sin resultados",
    "fields": {
      "name": "Nombre",
      "document": "Documento",
      "email": "Correo",
      "phone": "Teléfono",
      "internalCode": "Código interno",
      "sites": "Sedes",
      "status": "Estado",
      "address": "Dirección",
      "timezone": "Zona horaria",
      "location": "Ubicación",
      "empty": "—"
    },
    "active": "Activo",
    "inactive": "Inactivo",
    "coordinates": "{latitude}, {longitude}",
    "createTitle": "Crear nuevo en Fermin",
    "createHint": "Se creará sin invitación: tú decides cuándo invitar.",
    "createSiteHint": "La sede se creará con la ubicación que indiques.",
    "phone": "Teléfono",
    "phoneHelp": "El sistema externo no lo envía; quedará gestionado en Fermin.",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "timezone": "Zona horaria",
    "timezoneHelp": "Por ejemplo, America/Lima.",
    "required": "Completa este dato.",
    "invalidNumber": "Ingresa un número válido.",
    "link": "Vincular con {name}",
    "linkDisabled": "Vincular",
    "create": "Crear nuevo",
    "skip": "Omitir",
    "linked": "Caso resuelto: quedó vinculado",
    "created": "Caso resuelto: se creó en Fermin",
    "skipped": "Caso omitido; puedes volver a revisarlo cuando quieras",
    "statuses": {
      "ACTIVE": "Activo",
      "PENDING_ACTIVATION": "Pendiente de activación",
      "INACTIVE": "Inactivo"
    },
    "invalidPhone": "Teléfono inválido: entre 6 y 20 caracteres (dígitos, +, paréntesis, espacio o guion)."
  },
  "filters": {
    "legend": "Filtros de la bandeja",
    "status": "Estado",
    "statusOptions": {
      "OPEN": "Pendientes",
      "SKIPPED": "Omitidos"
    },
    "type": "Tipo",
    "typeOptions": {
      "ALL": "Todos",
      "SITE": "Sedes",
      "WORKER": "Trabajadores"
    }
  }
}
